import { CSSProperties } from "react"
import { ProfileMemberGrid } from "../ProfileMemberGrid";
import { useCommunityMemeberOpen } from "../../../../../hooks/manageMembers/useCommunityMemeberOpen";
import { ProfileMemberColumns } from "../consts/ProfileMemberColumns";
import Pagination from "../../../../components/Pagination";

type Props = {
    titleStyles: CSSProperties;
    userId: number;
    onSelect: (u: any) => void;
    reloadKey?: number;
}

export const ProfileMemberForum = ({ titleStyles, userId, onSelect, reloadKey }: Props) => {
    const { loading, open, openPage, openTotalPages, setOpenPage } = useCommunityMemeberOpen(userId, reloadKey);
    return (
        <div className="d-flex flex-column" style={{gap: '20px'}}>
            <span style={titleStyles}>
                Forum
            </span>
            <ProfileMemberGrid 
                data={open}
                loading={loading}
                columns={ProfileMemberColumns}
                onSelect={onSelect}
            />
            {!loading && open.length === 0 ? (
                <span className="text-center">There is nothing to show for now.</span>
            ): (
                <Pagination currentPage={openPage} totalPages={openTotalPages} onPageChange={setOpenPage} />
            )}
        </div>
    )
}